module.exports = __webpack_public_path__ + "img/PG2-8-475x323.591d59d6.png";